/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookmarkIcon16Light = forwardRef('BookmarkIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 3.5A2.5 2.5 0 0 1 4.5 1h6A2.5 2.5 0 0 1 13 3.5v10.52a1 1 0 0 1-1.514.857L7.5 12.486l-3.986 2.391A1 1 0 0 1 2 14.02V3.5ZM4.5 2A1.5 1.5 0 0 0 3 3.5v10.52l3.986-2.392a1 1 0 0 1 1.029 0L12 14.02V3.5A1.5 1.5 0 0 0 10.5 2h-6Z" })));
});
